import React from 'react';

import InsightsSection from 'components/Enterprise/InsightsSection';

type ContentWithImage = {
  heading: string;
  description: {
    description: string;
  };
  image: ImageType;
};

type ImageType = {
  fluid: {
    src: string;
  };
  description: string;
};

export interface InsightsContainerProps {
  content: {
    title: string;
    headline: string;
    listOfContentWithImages: ContentWithImage[];
    componentName: string;
    mobileImages: ImageType[];
    desktopImages: ImageType[];
  };
}

export const InsightsContainer: React.FC<InsightsContainerProps> = ({
  content,
}) => {
  if (!content) {
    return null;
  }

  const {
    title,
    headline,
    listOfContentWithImages,
    mobileImages: rawMobileImages,
    desktopImages: rawDesktopImages,
  } = content;

  const formattedListOfContent = listOfContentWithImages.map(item => {
    return {
      heading: item.heading,
      description: item.description?.description,
      imageSrc: item?.image?.fluid?.src,
      imageAlt: item?.image?.description,
    };
  });

  return (
    <InsightsSection
      title={title}
      headline={headline}
      listOfContent={formattedListOfContent}
      mobileImages={rawMobileImages.map(img => ({
        src: img.fluid.src,
        altText: img.description,
      }))}
      desktopImages={rawDesktopImages.map(img => ({
        src: img.fluid.src,
        altText: img.description,
      }))}
    />
  );
};

export default InsightsContainer;
